import { store } from "@/core/store"
import { telegramApi } from "@/modules/telegram/store/telegramApi"
import type { PagedEnqueueTransport } from "./types"

/** RTK-транспорт: рефреш-токены наследуются от baseQueryWithReauth.
 *  Страницы — track:false (мегабайтные аргументы не оседают в сторе/DevTools).
 *  Прогресс — forceRefetch:true + ручной unsubscribe в finally: subscribe:false
 *  в RTK 1.9.7 ломает unwrap() на холодном кеше (unwrap читает селектор стора,
 *  а pending без subscribe не создаёт кеш-запись → undefined). Выполненная
 *  запись прогресса держится в кеше до истечения keepUnusedDataFor — нагрузки
 *  минимум, fresh pagesDone гарантирован forceRefetch. */
export const createHttpTransport = (): PagedEnqueueTransport => {
  const dispatch = store.dispatch.bind(store)
  return {
    init: async (body) => {
      const res = await dispatch(
        telegramApi.endpoints.createMailingInit.initiate({ body }),
      ).unwrap()
      return { id: res.id }
    },
    sendPage: async (id, pageIndex, bodyJson) => {
      const res = await dispatch(
        telegramApi.endpoints.sendRecipientsPage.initiate(
          { pathParams: { id }, pageIndex, bodyJson },
          { track: false },
        ),
      ).unwrap()
      return { enqueued: res.enqueued }
    },
    commit: async (id, expectedTotal) => {
      const res = await dispatch(
        telegramApi.endpoints.commitMailing.initiate({
          pathParams: { id },
          body: { expectedTotal },
        }),
      ).unwrap()
      return { state: res.state }
    },
    progress: async (id) => {
      const sub = dispatch(
        telegramApi.endpoints.enqueueProgress.initiate(
          { pathParams: { id } },
          { forceRefetch: true },
        ),
      )
      try {
        return await sub.unwrap()
      } finally {
        sub.unsubscribe()
      }
    },
    finish: async (id) => {
      await dispatch(
        telegramApi.endpoints.finishMailing.initiate({ queryParams: { id } }),
      ).unwrap()
    },
    remove: async (id) => {
      await dispatch(
        telegramApi.endpoints.removeMailing.initiate({ queryParams: { id } }),
      ).unwrap()
    },
  }
}
